/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseString } from '../../models/api-response-string';
import { PagedRequestString } from '../../models/paged-request-string';

export interface RequestBroadcastDetailsSearchExcelExport$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  lang: string;
  exportContactAttribute?: boolean;
      body: PagedRequestString
}

export function requestBroadcastDetailsSearchExcelExport(http: HttpClient, rootUrl: string, params: RequestBroadcastDetailsSearchExcelExport$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseString>> {
  const rb = new RequestBuilder(rootUrl, requestBroadcastDetailsSearchExcelExport.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('lang', params.lang, {});
    rb.query('exportContactAttribute', params.exportContactAttribute, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseString>;
    })
  );
}

requestBroadcastDetailsSearchExcelExport.PATH = '/v1/api/ui/broadcast/details/export-excel-search-background/{lang}';
